import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HeadsetIcon from '@material-ui/icons/Headset';
import SearchIcon from '@material-ui/icons/Search';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import image from '../assets/images/hero.svg';
import imageProfile from '../assets/images/avatar.svg';

import { FeaturedPlaylists } from './FeaturedPlaylists';
import { NewReleases } from './NewReleases';
import { Categories } from './Categories';
import { SimpleBottomNavigation } from './MusicPlayer';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    backgroundColor: "#ffb5a7"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#574fd8",
    color: "white"
  },

  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    paddingLeft: "40px",
    paddingTop: "210px"
  },
}));

export default function Layout() {

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <img className="image-header" src={image} alt="Logo" />
          <div className="title-header">
            <h1>Your favourite tunes</h1>
            <h2>All day and all night</h2>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div className={classes.toolbar} />
        <img className="image-profile" src={imageProfile} alt="Logo" />
        <h3 className="profile-name">Oriol Hilari</h3>
        <List>
          <ListItem>
            <ListItemIcon><HeadsetIcon className="icon-drawer" /></ListItemIcon>
            <ListItemText>Discover</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon><SearchIcon className="icon-drawer" /></ListItemIcon>
            <ListItemText>Search</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon><FavoriteIcon className="icon-drawer" /></ListItemIcon>
            <ListItemText>Favourites</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon><PlayCircleFilledIcon className="icon-drawer" /></ListItemIcon>
            <ListItemText>Playlists</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon><ClearAllIcon className="icon-drawer" /></ListItemIcon>
            <ListItemText>Charts</ListItemText>
          </ListItem>
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <FeaturedPlaylists />
        <NewReleases />
        <Categories />
      </main>
        <SimpleBottomNavigation />
    </div>
  );
}
